module.exports = __webpack_public_path__ + "static/media/login.6c3cb82c.mp4";